"use client";

import { useEffect } from "react";

// Registra el service worker `/sw.js` para que Chrome/Android
// considere al sitio "installable" y dispare `beforeinstallprompt`.
// El SW ya existe (originalmente para push notifications) y hace
// install/activate + passthrough de `fetch` — suficiente para
// calificar como PWA sin cachear nada.
//
// Sin UI. Se monta desde `layout.tsx`.
export default function PWAInit() {
  useEffect(() => {
    if (typeof navigator === "undefined") return;
    if (!("serviceWorker" in navigator)) return;
    // No bloquear el render principal. Register en microtask.
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // Silent — si falla el registro, la PWA no se instala pero el
      // sitio sigue funcionando normal.
    });
  }, []);

  return null;
}
